import axios from "axios";

const API_URL = process.env.API_URL;

export async function getOnGoingHome(authorization) {
  const url = `${API_URL}/webclient/donation/ongoing-home`;
  return axios({
    url,
    method: "get",
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    },
  })
    .then((response) => response.data)
    .catch((err) => {
      throw err.response;
    });
}

export async function getOnGoingList(authorization) {
  const url = `${API_URL}/webclient/donation/ongoing`;
  return axios({
    url,
    method: "get",
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    },
  })
    .then((response) => response.data)
    .catch((err) => {
      throw err.response;
    });
}

export async function getDonationHistory(authorization, filter) {
  const url = `${API_URL}/webclient/account/donation-history`;
  return axios({
    url,
    method: "get",
    params: filter,
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    },
  })
    .then((response) => response.data)
    .catch((err) => {
      throw err.response;
    });
}

export async function getListDonationsPlan(authorization) {
  const url = `${API_URL}/webclient/donation/donation-plan`;
  return axios({
    url,
    method: "get",
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    },
  })
    .then((response) => response.data)
    .catch((err) => {
      throw err.response;
    });
}

export async function getOnGoingAnon() {
  const url = `${API_URL}/webclient/donation/ongoing-project`;
  return axios({
    url,
    method: "get",
  })
    .then((response) => response.data)
    .catch((err) => {
      throw err.response;
    });
}

export async function getDonationReceipt(authorization, id) {
  const url = `${API_URL}/webclient/account/donation-receipt/${id}`;
  return axios({
    url,
    method: "get",
    responseType: "blob",
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    },
  })
    .then((response) => response)
    .catch((err) => {
      throw err.response;
    });
}



// WEBPACK FOOTER //
// ./src/services/donations.js